// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"285":"70c7dabc","852":"d42cb232"}[chunkId] + ".css";
};